<ng-container *ngIf="state$ | async as state">

    <div class="planned-sale-volume-container mat-elevation-z8">
        <div class="planned-sale-volume-table-header">
            <mat-generic-input (inputFormGroupChange)="formgroupChange($event)" [fields]="layout.filterFields"></mat-generic-input>

            <div class="action-buttons">
                <button mat-mini-fab
                        (click)="openGenerateDialog()"
                        color="primary"
                        matTooltip="{{ 'app.page.planned-sale-volume.actions.generate.label' | translate }}">
                    <mat-icon>sync</mat-icon>
                </button>
                <button mat-mini-fab
                        (click)="openDialog()"
                        color="primary"
                        matTooltip="{{ 'app.page.planned-sale-volume.actions.add.label' | translate }}">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource" matSort>


                <ng-container matColumnDef="articleNr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.planned-sale-volume.articleNr.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element"> {{ element.costUnit.articleNr }}</td>
                </ng-container>

                <ng-container matColumnDef="costUnit">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.planned-sale-volume.cost-unit.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element"> {{ element.costUnit.name }}</td>
                </ng-container>

<!--                <ng-container matColumnDef="measureUnit">-->
<!--                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.planned-sale-volume.measure-unit.label" | translate }}</th>-->
<!--                    <td mat-cell *matCellDef="let element">{{element.measureUnit.name}}</td>-->
<!--                </ng-container>-->

                <ng-container matColumnDef="validFrom">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.planned-sale-volume.from.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.validFrom | date: 'dd.MM.yyyy' }}</td>
                </ng-container>

                <ng-container matColumnDef="validTo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.planned-sale-volume.to.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.validTo | date: 'dd.MM.yyyy' }}</td>
                </ng-container>

                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header>{{ "app.model.planned-sale-volume.amount.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.amount | number: '1.0-2' : 'de-DE' }}</td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" class="actions-column">
                        <button mat-icon-button
                                color="primary"
                                matTooltip="{{ 'app.page.planned-sale-volume.actions.edit.label' | translate }}"
                                (click)="openDialog(element)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button
                                color="warn"
                                matTooltip="{{ 'app.page.planned-sale-volume.actions.delete.label' | translate }}"
                                (click)="onDelete(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="layout.columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: layout.columns;"></tr>
            </table>
        </div>
        <mat-paginator [pageSize]="20" [pageSizeOptions]="[20, 50]"></mat-paginator>
    </div>

</ng-container>
